/* eslint-disable import/no-named-as-default */
import Chart from 'chart.js/auto'
import $ from 'jquery'

interface JsonData {
  [key: string]: number
}

interface CustomTooltipItem {
  dataset: {
    data?: number[] | number
  }
  dataIndex: number
}

// Explicit label -> color mapping so slice colors stay stable regardless of
// the order rows come back from the database. LABEL_ORDER also pins the
// slice/legend order so the pie always renders "Hitting benefits cliff" first.
const LABEL_COLORS: Record<string, string> = {
  'Hitting benefits cliff': '#FF6660',
  'Not hitting benefits cliff': '#0063F3',
}
const LABEL_ORDER = ['Hitting benefits cliff', 'Not hitting benefits cliff']
const FALLBACK_COLORS = ['#0063F3', '#FF6660']

const convertDataToChartjsFormat = (jsonData: JsonData) => {
  const entries = Object.entries(jsonData).sort(([a], [b]) => {
    const ai = LABEL_ORDER.indexOf(a)
    const bi = LABEL_ORDER.indexOf(b)
    if (ai === -1 && bi === -1) return 0
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })
  const labels = entries.map(([key, value]) => `${key}: ${value}`)
  const data = entries.map(([, value]) => value)
  const backgroundColor = entries.map(
    ([key], idx) =>
      LABEL_COLORS[key] ?? FALLBACK_COLORS[idx % FALLBACK_COLORS.length],
  )
  return { labels, data, backgroundColor }
}

const createPieChart = (element: HTMLElement, jsonData: JsonData) => {
  const pieData = convertDataToChartjsFormat(jsonData)
  const canvas = document.createElement('canvas')
  element.appendChild(canvas)

  new Chart(canvas, {
    type: 'pie',
    data: {
      labels: pieData.labels,
      datasets: [
        {
          data: pieData.data,
          backgroundColor: pieData.backgroundColor,
        },
      ],
    },
    options: {
      plugins: {
        tooltip: {
          callbacks: {
            label: ({ dataset, dataIndex }: CustomTooltipItem) => {
              const data: number[] = dataset.data as number[]
              const total = data.reduce((acc, val) => acc + val)
              const currentValue = data[dataIndex]
              const percentage = ((currentValue / total) * 100).toFixed(2)
              return ` ${Math.round(parseFloat(percentage))}%`
            },
          },
        },
        legend: {
          position: 'bottom',
          onClick: () => {
            return
          },
        },
      },
    },
  })
}

$(document).ready(() => {
  $('.pie-chart-chartjs').each(function (this: HTMLElement) {
    const jsonData: JsonData = $(this).data('pie')
    createPieChart(this, jsonData)
  })
})
